import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Chip, useTheme } from "@mui/material/index";
import { LinkOffRounded } from "@mui/icons-material";
import { CBOmissionType, CustomerBaseDto, IFormValues } from "../../types";
import { chipActionIcon, chipActionSx } from "./chipAction";
import { useDigitalIdentityUnlink } from "./useDigitalIdentityUnlink";

interface CBDigitalIdentityProps {
    customer: CustomerBaseDto | null
}

const CBDigitalIdentity = ({ customer }: CBDigitalIdentityProps) => {

    const theme = useTheme();
    const { t } = useTranslation("customerbase");
    const { control } = useFormContext<IFormValues>();
    // CR-DRIVALIA-EPCH (LPP-22837): sgancio dell'identita' digitale come azione in coda alla chip.
    const unlink = useDigitalIdentityUnlink(customer);

    const getChipColor = (value: string | null) => {
        const val = value == CBOmissionType.OMISSION_DASH ? '' : value;

        return !!val ? theme.palette.success.main : theme.palette.grey.A400;
    }


    return (
        <>
           <Controller
                control={control}
                name="cbDetails.idpUid"
                render={({field}) => (
                    <Chip
                        label={t("idpUid")}
                        onDelete={unlink.visible ? unlink.request : undefined}
                        deleteIcon={chipActionIcon(unlink.tooltip, <LinkOffRounded />)}
                        sx={{color: "white", backgroundColor: getChipColor(field.value), ...chipActionSx(unlink.disabled)}}
                    />
                )}
            />
            {unlink.modal}
        </>
    );

}

export default CBDigitalIdentity;
